import { FormApi } from 'final-form';
import arrayMutators from 'final-form-arrays';
import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import { OptionFormData } from 'modules/menu/types';

import { validateOptionForm } from './validators';

type Props = {
  initialValues: OptionFormData;
  onSubmit: (values: OptionFormData, form: FormApi<OptionFormData, Partial<OptionFormData>>) => void;
  children: (props: FormRenderProps<OptionFormData>) => React.ReactNode;
};

const OptionForm = ({ initialValues, onSubmit, children }: Props) => {
  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      mutators={{ ...arrayMutators }}
      validate={validateOptionForm}
      keepDirtyOnReinitialize
    >
      {children}
    </Form>
  );
};

export default OptionForm;
